/* eslint-disable camelcase */
import { ProductSearchObject, ProductSearchResult } from './types';

export const convertSearchObjectToSearchResult = ({
  id,
  relatedPageUid,
  url,
  title,
  description,
  sku,
  image_url,
  image_title,
  image_data,
  barcode_number,
  brand_name,
  segment_description,
  aroma_scent,
  net_content_statement,
  variant_and_icon,
  categories_title,
  product_brand_name,
}: ProductSearchObject): ProductSearchResult => ({
  id,
  relatedPageUid,
  productBrandName: product_brand_name,
  sku,
  title,
  description,
  url,
  image: {
    url: image_url,
    title: image_title,
    data: JSON.parse(image_data),
  },
  barcodeNumber: barcode_number,
  brandName: brand_name,
  segmentDescription: segment_description,
  aromaScent: aroma_scent,
  netContentStatement: net_content_statement,
  variantAndIcon: variant_and_icon,
  categoriesTitle: categories_title,
});
